import titles from "@/store/lang/titles.json";
import { mapGetters, mapActions } from "vuex";
import Success from "../success/Success.vue";
import Tooltip from "../tooltip/tooltip.vue";
import InvisibleRecaptcha from "vue-invisible-recaptcha";
export default {
  name: "WholesaleQuote",
  components: {
    Success,
    Tooltip,
    InvisibleRecaptcha,
  },
  data() {
    return {
      WholesaleQuotesTitles: titles.WholesaleQuotesTitles,
      creditApplicationTitles: titles.creditApplicationTitles,
      numberOfContainers: 10,
      rulesTitle: titles.rulesTitle.wholesaleQuote,
      panelOpen: 0,
      sizeTick: false,
      containerTypeTick: false,
      numberOfContainersTick: false,
      deliveryDetailsTick: false,
      isContainerSizeValid: false,
      isContainerTypeValid: false,
      isDeliveryDetailsValid: false,
      isNumberOfContainersValid: false,
      isOtherFormsCompleteTick: false,
      isCreditApplicationTick: false,
      isCreditApplicationValid: false,
      rules: {
        nameRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.fieldIsRequired,
        ],
        containerSizeRules: [
          (v) => v.length > 0 || titles.rulesTitle.wholesaleQuote.containerSize,
        ],
        accountContactNameRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.fullName,
        ],
        zipCodeRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.zipCode,
          (v) =>
            (!isNaN(parseFloat(v)) && v.length == 5) ||
            titles.rulesTitle.creditApplication.validZipcode,
        ],
        emailRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.email,
          (v) =>
            /.+@.+/.test(v) || titles.rulesTitle.creditApplication.validEmail,
        ],
        phoneNumberRules: [
          (v) => !!v || titles.rulesTitle.creditApplication.phoneNumber,
          function(v) {
            if (v) {
              let value = v.replace(/\D/g, "");
              return (
                (!isNaN(parseFloat(value)) && value.length == 10) ||
                titles.rulesTitle.creditApplication.validPhoneNum
              );
            }
            return titles.rulesTitle.creditApplication.validPhoneNum;
          },
        ],
        dateRules: [(v) => !!v || titles.rulesTitle.wholesaleQuote.date],
      },
      requestForm: {
        event_type: "wholesale_quote_request",
        business_name: "",
        additional_info: "",
        account_info: {
          email: "",
          name: "",
          phone: "",
        },
        business_addr: {
          city: "",
          state: "",
          street: "",
          zipCode: "",
        },
        delivery_date: "",
        container_sizes: [],
        container_type: "",
        number_of_containers: null,
        CountryCode: "",
      },
      isSubmitSuccessful: false,
      activeStep: 1,
      animation: "animate-in",
      dateFormatted: "",
      menu: false,
      date: "",
      isSubmitting: false,
    };
  },
  computed: {
    ...mapGetters(["getCountryCode"]),
    progress(){
      
      var pg =  (this.activeStep-1)/ 5*100;
      
      return pg;

    },
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    ...mapActions(["addFormRequest"]),
    increment() {
      this.numberOfContainers = parseInt(this.numberOfContainers, 10) + 1;
    },
    decrement() {
      this.numberOfContainers = parseInt(this.numberOfContainers, 10) - 1;
    },
    validateContainerSizeField() {
      this.isContainerSizeValid = this.$refs.containerSizeForm.validate();
      this.sizeTick = this.isContainerSizeValid;
    },
    validateContainerTypeField() {
      this.isContainerTypeValid = this.$refs.containerTypeForm.validate();
      this.containerTypeTick = this.isContainerTypeValid;
    },
    validateCreditApplicationField() {
      this.isCreditApplicationValid = this.$refs.creditApplicationForm.validate();
      this.isCreditApplicationTick = this.isCreditApplicationValid;
      this.$refs.creditApplicationForm.validate();
    },
    validateDeliveryDetailsField() {
      this.isDeliveryDetailsValid = this.requestForm.delivery_date
        ? true
        : false;
      this.deliveryDetailsTick = this.isDeliveryDetailsValid;
      this.$refs.deliveryDetailsForm.validate();
    },
    validateQuantityField() {
      this.isNumberOfContainersValid = this.requestForm.number_of_containers
        ? true
        : false;
      this.numberOfContainersTick = this.isNumberOfContainersValid;
      this.$refs.numberOfContainersForm.validate();
    },
    getNextPanel(event, idx) {
      switch (idx) {
        case 1:
          this.validateContainerSizeField();
          !this.isContainerSizeValid ? this.notValid() : this.nextStep();
          break;
        case 2:
          this.validateContainerTypeField();
          !this.isContainerTypeValid ? this.notValid() : this.nextStep();
          break;
        case 3:
          this.validateQuantityField();
          !this.isNumberOfContainersValid ? this.notValid() : this.nextStep();
          break;
        case 4:
          this.requestForm.delivery_date = this.dateFormatted;
          this.validateDeliveryDetailsField();
          !this.isDeliveryDetailsValid ? this.notValid() : this.nextStep();
          break;
        case 5:
          this.isOtherFormsCompleteTick = true;
          this.nextStep();
          break;
        case 6:
          this.validateCreditApplicationField();
          !this.isCreditApplicationValid ? this.notValid() : this.submit();
          break;
      }
    },
    submit() {
      this.requestForm.CountryCode = this.getCountryCode;
      this.isSubmitting = true;
      if (this.isCreditApplicationValid) {
        this.panelOpen = null;
        this.addFormRequest({
          data: this.requestForm,
          event_type: this.requestForm.event_type,
        })
          .then((response) => {
            if (
              response &&
              response.data &&
              response.data.ResponseMetadata &&
              response.data.ResponseMetadata.HTTPStatusCode == 200
            )
              this.isSubmitSuccessful = true;
            else alert("Oops! something went wrong");
            this.isSubmitting = false;
          })
          .catch((err) => {
            console.log(err);
            this.isSubmitting = false;
          });
      }
    },
    getRequestForm() {
      this.requestForm = {
        event_type: "wholesale_quote_request",
        business_name: "",
        additional_info: "",
        account_info: {
          email: "",
          name: "",
          phone: "",
        },
        business_addr: {
          city: "",
          state: "",
          street: "",
          zipCode: "",
        },
        delivery_date: "",
        container_sizes: [],
        container_type: "",
        number_of_containers: 10,
        CountryCode: this.getCountryCode,
      };
      this.isSubmitSuccessful = false;
      this.activeStep = 1;
      this.sizeTick = false;
      this.containerTypeTick = false;
      this.numberOfContainersTick = false;
      this.deliveryDetailsTick = false;
      this.isOtherFormsCompleteTick = false;
      this.isCreditApplicationTick = false;
    },
    nextStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep += 1;
      }, 600);
    },
    priorStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep -= 1;
      }, 600);
    },
    notValid() {
      this.animation = "animate-wrong";
      setTimeout(() => {
        this.animation = "";
      }, 400);
    },
    getPriorPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 2:
          this.priorStep();
          break;
        case 3:
          this.priorStep();
          break;
        case 4:
          this.priorStep();
          break;
        case 5:
          this.priorStep();
          break;
        case 6:
          this.priorStep();
          break;
      }
    },
    getStepperContent(step) {
      this.activeStep = step;
      switch (step) {
        case 1:
          this.sizeTick = false;
          break;
        case 2:
          this.containerTypeTick = false;
          break;
        case 3:
          this.numberOfContainersTick = false;
          break;
        case 4:
          this.deliveryDetailsTick = false;
          break;
        case 5:
          this.isOtherFormsCompleteTick = false;
          break;
        case 6:
          this.isCreditApplicationTick = false;
          break;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    isAllValid() {
      return (
        !(
          this.sizeTick &&
          this.containerTypeTick &&
          this.numberOfContainersTick &&
          this.deliveryDetailsTick &&
          this.isOtherFormsCompleteTick &&
          this.$refs &&
          this.$refs.creditApplicationForm &&
          this.$refs.creditApplicationForm.validate()
        ) || this.isSubmitting
      );
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      this.getNextPanel(null, this.activeStep);
    },
  },
};
